export const baseTheme = {
  color: {
    primary: "#1B65A7",
    primaryDarker: "#144E81",
    primaryBackground: "#E9F1F9",
    primaryBackgroundDarker: "#d8e3f8",
    second: "rgb(34, 37, 49)",
    third: "#667085",
    fourth: "rgb(239, 242, 245)",
    border: "#D0D5DD",
    borderLight: "rgb(235,235,235)",
    background: "#F7F7F7",
    backgroundDarker: "rgb(235,235,235)",
    backgroundOpacity: "rgba(0,0,0,0.2)",
    backgroundGradient:
      "background: linear-gradient(180deg, rgba(235,235,235, 0) 0%, rgba(235,235,235, 1) 100%)",
    backgroundGradientRotate:
      "background: linear-gradient(90deg, rgba(235,235,235, 0) 0%, rgba(235,235,235, 1) 100%)",
    redGradient: "background: linear-gradient(90deg, #ED4438 0%, #922119 100%)",
    orangeGradient: "background: linear-gradient(90deg, #F8B087 0%, #EF6921 100%)",
    primaryGradient: "background: linear-gradient(90deg, #93CBFE 0%, #1D67A7 100%)",

    white: "#fff",
    purple: "#5F2EEA",
    blue: "#007AFF",
    red: "#F8563F",
    redBackground: "rgb(253, 237, 237)",
    orange: "#df9434",
    orangeBackground: "rgb(255, 244, 229)",
    green: "#5EAF63",
    greenBackground: "rgb(237, 247, 237)",
    greenDarker: "#3a8a3f",
    orangeDarker: "#ba7114",
  },
  font: {
    XXXXL: "26px",
    XXXL: "24px",
    XXL: "20px",
    XL: "18px",
    L: "16px",
    M: "14px",
    S: "12px",
    XS: "10px",
    XXS: "5px",
    light: 400,
    normal: 500,
    bold: 600,
    extraBold: 700,
  },
  space: {
    XXL: "10rem",
    XL: "5rem",
    L: "2.5rem",
    M: "2rem",
    S: "1rem",
    XS: "10px",
    XXS: "5px",
  },
  variable: {
    borderRadius: "5px",
    borderRadiusButton: "5px",
    borderRadiusOuter: "5px",
    borderRadiusXSOuter: "5px",
    borderRadiusLarge: "10px",
    borderRadiusXLarge: "15px",
    maxWidth: "1600px",
    boxShadow: "0px 0px 25px 0px rgba(0,0,0,0.05)",
  },
}

export type colorKeyType = keyof typeof baseTheme.color
export type fontKeyType = keyof typeof baseTheme.font
export type spaceKeyType = keyof typeof baseTheme.space
export type variableKeyType = keyof typeof baseTheme.variable

export const roadheroBaseTheme = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    primary: "#FB7525",
    primaryDarker: "#fa6309",
    primaryBackground: "rgba(251, 117, 37, 0.1)",
  },
}
